// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1TlW2","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2PChb","obliqueLine":"membershipbadge_obliqueLine__1CirH"};